import React from "react";
import { useNavigate } from "react-router-dom";
import { slugify, formatPostDate } from "../../utils/slug";
import "./Post.css";

const Post = ({ title, text, image, date }) => {
  const navigate = useNavigate();

  const openPost = () => {
    navigate(`/aktualnosci/${slugify(title)}`);
  }

  return (
    <div className="post-panel" onClick={openPost} >
      <h2 onClick={openPost} className="post-title" >{title}</h2>
      {image && <img onClick={openPost} src={image} alt={title} className="post-preview-image" />}
      {date && <p onClick={openPost} className="post-date">{formatPostDate(date)}</p>}
      <p onClick={openPost} className="post-preview-text" >{text}</p>
    </div>
  );
};

export default Post;
